<template>
  <div class="home_doctor">
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <results></results>
      </div>
      <!--
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6">
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
  import Results from './components/Tasks.vue'

  export default {
    data () {
      return {
        //
      }
    },
    components: {
      Results
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Task/Task.vue?9a6b7968